module.exports = __webpack_public_path__ + "img/AOnePerson.d82fa012.png";